export default "__VITE_ASSET__C9PscL0j__"